import { ConnectedPosition } from '@angular/cdk/overlay';

export enum PositionEnum {
  default = '',
  center = 'center',
  bottom = 'bottom',
  bottomLeft = 'bottom-left',
  bottomRight = 'bottom-right',
  left = 'left',
  right = 'right',
  top = 'top',
  topLeft = 'top-left',
  topRight = 'top-right'
}

export type PositionConfig = Partial <Record <PositionEnum, ConnectedPosition>>;
